import { WithLoader } from 'Components/WithLoader'
import type { TicketSale } from 'Services/SalesManagement/Features/TicketSale/types'
import { base64ToBinaryString } from 'Util/formatters'
import { Box } from '@mui/material'
import QRCode from 'qrcode-generator'
import { useEffect, useState } from 'react'
import { t } from 'ttag'

interface TicketSaleQRCodeProps {
  ticketSale: TicketSale
}

export default function TicketSaleQRCode({ ticketSale }: Readonly<TicketSaleQRCodeProps>) {
  const [qrCodeUrl, setQrCodeUrl] = useState<string | undefined>(undefined)

  const generateQRCode = (ticketData: string) => {
    try {
      // The ticket data received from the backend is base64 encoded, so we need to decode it first
      // before passing it to the QR code generator
      const decodedBinaryString = base64ToBinaryString(ticketData)
      const qr = QRCode(0, 'L') // type number 0 = auto, error correction L = low
      qr.addData(decodedBinaryString, 'Byte')
      qr.make()
      const dataUrl = qr.createDataURL()
      setQrCodeUrl(dataUrl)
    } catch (error) {
      setQrCodeUrl('')
      console.error('Failed to generate QR code:', error)
    }
  }

  useEffect(() => {
    generateQRCode(ticketSale.ticket_data)
  }, [ticketSale.ticket_data])

  const isLoading = qrCodeUrl === undefined
  const isError = qrCodeUrl === ''
  return (
    <WithLoader loading={isLoading}>
      <Box sx={{ p: 2 }}>
        {isError ? (
          <span>{t`Failed to generate QR code.`}</span>
        ) : (
          <img src={qrCodeUrl} alt={t`QR Code`} />
        )}
      </Box>
    </WithLoader>
  )
}
